export default __webpack_public_path__ + "static/media/p-minus-4.f1d3706e.svg";